<template>
  <div
    v-if="isSmall"
    class="tw:border tw:border-b-0 tw:lg:border-b tw:lg:border-r-0 tw:border-gray-300 tw:flex tw:flex-row tw:items-center tw:h-auto tw:gap-x-2 tw:p-3 tw:rounded-t-lg tw:lg:rounded-t-none tw:lg:rounded-l-lg"
  >
    <p class="title tw:font-bold tw:inline tw:text-sm tw:items-start tw:gap-x-1" v-html="$t('rc_campaign_type_head')" />

    <div
      class="tw:flex tw:items-center tw:justify-start tw:px-2 tw:py-1 tw:rounded-lg tw:text-sm tw:font-bold"
      :class="statusColors"
    >
      {{ $t(campaignStatusKeys[campaignStatus]) }}
    </div>
  </div>
  <Card
    v-else
    :title="$t('rc_campaign_type_head')"
    :hint="campaignType === 'netCpa' ? $t('rc_ncpa_campaign_tooltip') : $t('rc_cpc_campaign_tooltip')"
    :isActionable="isActionable"
    :isCustomTooltip="false"
    type="campaignStatus"
    :hasHint="hasHint"
  >
    <template #cardData>
      <div
        class="tw:flex tw:items-center tw:justify-start tw:px-2 tw:py-1 tw:rounded tw:text-sm tw:font-bold"
        :class="statusColors"
      >
        {{ $t(campaignStatusKeys[campaignStatus]) }}
      </div>
    </template>
    <template #dropdownMenu="{ closeMenu }">
      <div
        class="tw:px-4 tw:py-3 tw:text-sm tw:hover:bg-blue-200 tw:hover:text-blue-800"
        :class="campaignStatus === 'PAUSED_UNTIL' ? 'tw:rounded-t-lg' : 'tw:rounded-lg'"
        @click="campaignAction(closeMenu)"
      >
        {{ campaignStatus === 'ACTIVE' ? $t('rc_deactivate_campaign_button') : $t('rc_reactivate_campaign_button') }}
      </div>
      <div
        v-if="campaignStatus === 'PAUSED_UNTIL'"
        :class="campaignStatus === 'PAUSED_UNTIL' ? 'tw:rounded-b-lg' : 'tw:rounded-lg'"
        class="tw:px-4 tw:py-3 tw:text-sm tw:hover:bg-blue-200 tw:hover:text-blue-800"
        @click="editPauseUntil(closeMenu)"
      >
        {{ $t('rc_adjust_resume_date') }}
      </div>
    </template>
  </Card>
</template>
<script setup>
import { computed } from 'vue'

import Card from '@/components/rateConnect/statusBar/Card.vue'

import { selectedAccommodationId } from '@/layouts/queries'
import { useRateConnect } from '@/components/rateConnect/useRateConnect.js'

import appAnalytics from '@/utils/tracking'

const { togglePauseCampaign, toggleResumeCampaign } = useRateConnect()

const props = defineProps({
  isActionable: Boolean,
  campaignType: String,
  unavailabilityRate: [Number, null, String],
  partnerStatus: String,
  budgetPercentage: [String, Number],
  hasHint: Boolean,
  campaignStatus: {
    type: String,
    default: 'ACTIVE',
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
})

const campaignStatusKeys = {
  ACTIVE: 'rc_provider_status_active',
  PAUSED: props.campaignType === 'cpc' ? 'rc_settings_campaign_off' : 'rc_campaign_status_inactive',
  PAUSED_UNTIL: 'rc_settings_campaign_off',
  PAUSED_FOR_BUDGET: 'rc_cpc_budget_status',
}

const statusColors = computed(() => {
  if (props.campaignStatus === 'PAUSED' || props.campaignStatus === 'PAUSED_UNTIL') {
    return 'tw:bg-red-200 tw:text-red-700'
  } else if (
    (props.campaignType === 'netCpa' && Number(props.unavailabilityRate) === 100) ||
    props.partnerStatus === 'inactive' ||
    (props.campaignType === 'cpc' && Number(props.budgetPercentage) <= 0) ||
    (props.campaignType === 'cpc' && isNaN(props.budgetPercentage)) ||
    props.campaignStatus === 'PAUSED_FOR_BUDGET'
  ) {
    return 'tw:bg-gray-200 tw:text-gray-700'
  } else if (props.campaignStatus === 'ACTIVE') {
    return 'tw:bg-green-200 tw:text-green-700'
  } else return ''
})

const editPauseUntil = closeMenu => {
  togglePauseCampaign('open', true)
  appAnalytics.track(appAnalytics.events.RC_STATUS_BAR_MENU_OPTION_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    cardType: 'campaignStatus',
    option: 'editCampaignPause',
    campaignType: props.campaignType,
  })
  closeMenu()
}
const campaignAction = closeMenu => {
  appAnalytics.track(appAnalytics.events.RC_STATUS_BAR_MENU_OPTION_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    cardType: 'campaignStatus',
    option: props.campaignStatus === 'ACTIVE' ? 'pauseCampaign' : 'resumeCampaign',
    campaignType: props.campaignType,
  })

  if (props.campaignStatus === 'ACTIVE') {
    togglePauseCampaign('open', false)
  } else {
    toggleResumeCampaign('open')
  }
  closeMenu()
}
</script>
